import type { LetterContent } from '@/types/recipientEmail';

import { parseCandidateBytes } from './candidateBytes';
import parseCandidateEmail, { candidateContentFromNode } from './parseCandidateEmail';

const parseRecipientEmail = (bytes: Uint8Array): LetterContent => {
    const decoded = parseCandidateBytes(bytes);
    const content = decoded.node ? candidateContentFromNode(decoded.node) : parseCandidateEmail(decoded.raw);
    return { ...content, warning: decoded.warning };
};

export default parseRecipientEmail;
